/**
 * Frontend JavaScript for Tabbed Content Block.
 */
document.addEventListener("DOMContentLoaded", function () {
	// Get all tab blocks on the page
	const tabBlocks = document.querySelectorAll(".tabbed-content-block");

	// Function to check if we're in mobile view
	const isMobileView = () => window.innerWidth <= 992;

	// Flag to track initial page load
	let isInitialLoad = true;

	// Function to move panel elements
	const handleTabDisplay = (tabBlock, activeTabIndex, shouldFocus = true) => {
		const tabs = tabBlock.querySelectorAll(".tabbed-content-tab");
		const panels = tabBlock.querySelectorAll(".tabbed-content-panel");
		const tabsContainer = tabBlock.querySelector(".tabbed-content-tabs");
		const panelsContainer = tabBlock.querySelector(".tabbed-content-panels");

		// Reset all tabs and panels
		tabs.forEach((tab) => {
			tab.classList.remove("active");
			tab.setAttribute("aria-selected", "false");
			tab.setAttribute("tabindex", "-1");
		});

		panels.forEach((panel) => {
			panel.classList.remove("active");
			panel.setAttribute("aria-hidden", "true");

			// If panel was moved out of its container, move it back
			if (panel.parentElement !== panelsContainer) {
				panelsContainer.appendChild(panel);
			}
		});

		// Set the active tab
		if (tabs[activeTabIndex]) {
			tabs[activeTabIndex].classList.add("active");
			tabs[activeTabIndex].setAttribute("aria-selected", "true");
			tabs[activeTabIndex].setAttribute("tabindex", "0");

			// Only focus if this is not the initial page load and shouldFocus is true
			if (shouldFocus && !isInitialLoad) {
				tabs[activeTabIndex].focus();
			}
		}

		// Set the active panel
		if (panels[activeTabIndex]) {
			panels[activeTabIndex].classList.add("active");
			panels[activeTabIndex].setAttribute("aria-hidden", "false");

			// If we're in mobile view, move the panel after its tab
			if (isMobileView()) {
				const activeTab = tabs[activeTabIndex];
				tabsContainer.insertBefore(
					panels[activeTabIndex],
					activeTab.nextSibling,
				);

				// Scroll to the panel if not initial load and should focus
				if (shouldFocus && !isInitialLoad) {
					setTimeout(() => {
						panels[activeTabIndex].scrollIntoView({
							behavior: "smooth",
							block: "nearest",
						});
					}, 100);
				}
			}
		}
	};

	// Set up ARIA attributes and tabindex for tabs
	const setupAccessibility = (block) => {
		const tabs = block.querySelectorAll(".tabbed-content-tab");
		const panels = block.querySelectorAll(".tabbed-content-panel");
		const blockId =
			block.id ||
			`tabbed-content-${Math.random().toString(36).substring(2, 11)}`;

		// Set up tablist attributes
		const tabsContainer = block.querySelector(".tabbed-content-tabs");
		tabsContainer.setAttribute("role", "tablist");
		tabsContainer.setAttribute(
			"aria-orientation",
			isMobileView() ? "vertical" : "horizontal",
		);

		// Set up tab attributes
		tabs.forEach((tab, index) => {
			const tabId = `${blockId}-tab-${index}`;
			const panelId = `${blockId}-panel-${index}`;

			// Set tab attributes
			tab.setAttribute("role", "tab");
			tab.setAttribute("id", tabId);
			tab.setAttribute("aria-controls", panelId);
			tab.setAttribute("aria-selected", index === 0 ? "true" : "false");
			tab.setAttribute("tabindex", index === 0 ? "0" : "-1");

			// Set panel attributes
			if (panels[index]) {
				panels[index].setAttribute("role", "tabpanel");
				panels[index].setAttribute("id", panelId);
				panels[index].setAttribute("aria-labelledby", tabId);
				panels[index].setAttribute(
					"aria-hidden",
					index === 0 ? "false" : "true",
				);
			}
		});
	};

	// Handle keyboard navigation
	const handleKeyboardNavigation = (event, block, currentIndex) => {
		const tabs = block.querySelectorAll(".tabbed-content-tab");
		const isHorizontal = !isMobileView();
		let newIndex = currentIndex;

		// Handle keyboard navigation
		switch (event.key) {
			case "ArrowRight":
				if (isHorizontal) newIndex = (currentIndex + 1) % tabs.length;
				break;
			case "ArrowLeft":
				if (isHorizontal)
					newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
				break;
			case "ArrowDown":
				if (!isHorizontal) newIndex = (currentIndex + 1) % tabs.length;
				break;
			case "ArrowUp":
				if (!isHorizontal)
					newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
				break;
			case "Home":
				newIndex = 0;
				break;
			case "End":
				newIndex = tabs.length - 1;
				break;
			case "Enter":
			case " ": // Space key
				handleTabDisplay(block, currentIndex, true);
				event.preventDefault(); // Prevent scrolling on space
				return;
			default:
				return; // Do nothing for other keys
		}

		// If index changed, update display and prevent default
		if (newIndex !== currentIndex) {
			handleTabDisplay(block, newIndex, true);
			event.preventDefault();
		}
	};

	// Process each tab block
	tabBlocks.forEach(function (block) {
		// Setup accessibility attributes
		setupAccessibility(block);

		// Set initial state (first tab active) without focusing
		handleTabDisplay(block, 0, false);

		// Add click event to each tab
		const tabs = block.querySelectorAll(".tabbed-content-tab");
		tabs.forEach(function (tab, index) {
			// Click event
			tab.addEventListener("click", function () {
				handleTabDisplay(block, index, true);
			});

			// Keyboard event
			tab.addEventListener("keydown", function (event) {
				handleKeyboardNavigation(event, block, index);
			});
		});
	});

	// After initialization, set isInitialLoad to false
	setTimeout(() => {
		isInitialLoad = false;
	}, 100);

	// Handle resize events
	let resizeTimer;
	window.addEventListener("resize", function () {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function () {
			tabBlocks.forEach(function (block) {
				// Update orientation attribute based on current view
				const tabsContainer = block.querySelector(".tabbed-content-tabs");
				tabsContainer.setAttribute(
					"aria-orientation",
					isMobileView() ? "vertical" : "horizontal",
				);

				// Find active tab and update display without focus
				const activeTabIndex = Array.from(
					block.querySelectorAll(".tabbed-content-tab"),
				).findIndex((tab) => tab.classList.contains("active"));

				if (activeTabIndex >= 0) {
					handleTabDisplay(block, activeTabIndex, false);
				}
			});
		}, 250);
	});
});
